// V2.3.0 优化解锁页档位显示逻辑 —— 挽留弹窗门槛标记
// 需求：.claude/docs/需求/H5小说站 - V2.3.0_优化解锁页档位显示逻辑/需求20261016.md

// 「创建过订单」：标签页会话级（sessionStorage）。
// 支付走 approve_url 跳转回跳后页面重载仍在，关闭标签页过期 —— 对应需求"从进入到退出阅读页未创建过订单"
const ORDER_CREATED_KEY = '__payOrderCreated'

export const markOrderCreated = () => {
  if (typeof window === 'undefined') return
  try {
    sessionStorage.setItem(ORDER_CREATED_KEY, '1')
  } catch {
    // 存储不可用（隐私模式等）当无标记
  }
}

export const hasCreatedOrder = () => {
  if (typeof window === 'undefined') return false
  try {
    return sessionStorage.getItem(ORDER_CREATED_KEY) === '1'
  } catch {
    return false
  }
}

// 挽留弹窗「每天只触发一次」：全站级（localStorage 存日期，本地时区日界）
const RETENTION_SHOWN_KEY = '__retentionShownDate'

// 本地时区年月日，如 2026-10-16
const todayStr = () => {
  const d = new Date()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${m}-${day}`
}

export const markRetentionShownToday = () => {
  if (typeof window === 'undefined') return
  try {
    localStorage.setItem(RETENTION_SHOWN_KEY, todayStr())
  } catch {
    // 同上
  }
}

export const retentionShownToday = () => {
  if (typeof window === 'undefined') return false
  try {
    return localStorage.getItem(RETENTION_SHOWN_KEY) === todayStr()
  } catch {
    return false
  }
}
